import { useState } from 'react';
import { CircularProgress, Grid } from "@mui/material";
import { useGetRelatedSessionsQuery } from '../services/api';
import SessionCard from './SessionCard';
import SessionDialog from './SessionDialog';
import { useNavigate } from 'react-router-dom';

type Props = {
  guid?: string
}

function RelatedSessions({
  guid,
}: Props) {
  if (!guid)
    return null;

  return <RelatedSessionsInternal
    guid={guid}
  />;
}

const RelatedSessionsInternal = ({
  guid,
}: Props) => {
  const { data: sessions, isLoading } = useGetRelatedSessionsQuery(guid);
  const [selectedSession, setSelectedSession] = useState<string | undefined>(undefined)
  const navigate = useNavigate();
  const onSelectSession = (selected?: string) => {
    setSelectedSession(selected)
    navigate(`/dashboard/${selected ?? guid}`)
  }
  if (isLoading)
    return <CircularProgress />

  return (
    <>
      <Grid
        container
        spacing={1}
      >
        {sessions?.map((session, index) => (
          <SessionCard
            index={index}
            key={session.guid}
            onClick={() => onSelectSession(session.guid)}
            session={session}
          />
        ))}
      </Grid>
      <SessionDialog
        onClose={() => onSelectSession(undefined)}
        guid={selectedSession}
      />
    </>
  );
}

export default RelatedSessions